// extracted by mini-css-extract-plugin
module.exports = {"noMatch":"NoMatchPage_noMatch__Wc_um","error":"NoMatchPage_error__2LOxb","message":"NoMatchPage_message__KzU84"};